import {createSlice} from '@reduxjs/toolkit'

export const alertSlice = createSlice({
    name: 'alert',
    initialState: {
        success: '',
        error: '',
        confirmIsActive: false
    },
    reducers: {
        setSuccess: (state, {payload}) => {
            state.success = payload
        },
        setError: (state, {payload}) => {
            state.error = payload
        },
        setConfirmIsActive: (state, {payload}) => {
            state.confirmIsActive = payload
        }
    }
})

export const {setError, setSuccess, setConfirmIsActive} = alertSlice.actions

export default alertSlice.reducer

